export default "__VITE_ASSET__52720afb__"